import { AspectRatio } from "@/components/ui/aspect-ratio";

interface BlogImageProps {
  src: string;
  alt: string;
  ratio?: number;
  loading?: "eager" | "lazy";
  className?: string;
}

export const BlogImage = ({
  src,
  alt,
  ratio = 16 / 9,
  loading = "lazy",
  className = "",
}: BlogImageProps) => {
  return (
    <AspectRatio ratio={ratio} className={`overflow-hidden bg-muted ${className}`}>
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        loading={loading}
      />
      {/* Dark orange overlay tint */}
      <div className="absolute inset-0 bg-gradient-to-br from-accent/20 via-accent/10 to-transparent pointer-events-none" />
    </AspectRatio>
  );
};
